var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('staff-list',_vm._g(_vm._b({attrs:{"is-loading":_vm.isLoading,"location":_vm.location,"staffs":_vm.staffs,"show-all-filter":"","page-size":_vm.pageSize,"total":_vm.total}},'staff-list',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }